import { render, staticRenderFns } from "./SpacePopover.vue?vue&type=template&id=63f2efea&scoped=true"
import script from "./SpacePopover.vue?vue&type=script&lang=ts"
export * from "./SpacePopover.vue?vue&type=script&lang=ts"
import style0 from "./SpacePopover.vue?vue&type=style&index=0&id=63f2efea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2efea",
  null
  
)

export default component.exports